import React, { useState } from "react";

function initials(name) {
  return name
    .replace(/^Dr\.?\s+/i, "")
    .split(/\s+/)
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function TeamPhoto({ photo, name }) {
  const [failed, setFailed] = useState(false);
  if (!photo || failed) {
    return <div className="team-photo team-photo--initials" aria-hidden="true">{initials(name)}</div>;
  }
  return (
    <div className="team-photo">
      <img
        src={photo}
        alt={name}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    </div>
  );
}

export default function Team({ data }) {
  if (!data) return null;
  return (
    <section id="team" className="section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">{data.eyebrow}</span>
          <h2 className="display-2">{data.title}</h2>
        </div>

        <div className="team-grid">
          {data.members.map((m, i) => (
            <article key={i} className="team-member">
              <TeamPhoto photo={m.photo} name={m.name} />
              <span className="mono-label team-role">{m.role}</span>
              <h3 className="team-name">{m.name}</h3>
              {m.credentials && (
                <div className="team-credentials">{m.credentials}</div>
              )}
              <p className="team-bio">{m.bio}</p>
              {m.linkedin && (
                <a
                  className="team-link"
                  href={m.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on LinkedIn →
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
